import React, { useState } from "react";
import { Send, Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/wolfApi";
import { toast } from "sonner";

export const AlbumBlastPanel = () => {
  const [testEmail, setTestEmail] = useState("");
  const [sending, setSending] = useState(null);
  const [result, setResult] = useState(null);

  const send = async (payload, mode) => {
    setSending(mode);
    try {
      const r = await api.post("/merch/albums/blast", payload);
      setResult(r.data);
      toast.success(mode === "test" ? `Test sent to ${r.data.sent_to}` : `Blast sent to ${r.data.sent_count} pack members 🐺`);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setSending(null);
    }
  };

  return (
    <div className="mt-6 bg-[#111111] border border-[#D4AF37]/25 p-6" data-testid="album-blast-panel">
      <p className="text-[10px] uppercase tracking-[0.32em] text-[#D4AF37]/90 mb-3">— Album Blast · Admin</p>
      <p className="text-sm text-white/60">
        Email the whole hype list + newsletter: <span className="text-white/85">GODWOLF</span> (Spotify / Apple) and{" "}
        <span className="text-white/85">Peace With Teeth</span> (free on BandLab). Each address only ever gets it once.
      </p>

      <div className="mt-4 flex gap-2">
        <input
          type="email"
          value={testEmail}
          onChange={(e) => setTestEmail(e.target.value)}
          placeholder="Send a test to yourself first…"
          data-testid="album-blast-test-email"
          className="flex-1 bg-[#0d0d0d] border border-white/15 focus:border-[#D4AF37] outline-none text-sm text-white px-3 py-2.5"
        />
        <button
          onClick={() => testEmail && send({ test_email: testEmail }, "test")}
          disabled={!testEmail || sending !== null}
          data-testid="album-blast-test-btn"
          className="text-[10px] uppercase tracking-[0.25em] text-[#D4AF37] border border-[#D4AF37]/40 hover:border-[#D4AF37] disabled:opacity-50 px-4 py-2.5 transition-colors"
        >
          {sending === "test" ? <Loader2 size={12} className="animate-spin" /> : "Test"}
        </button>
      </div>

      <button
        onClick={() => window.confirm("Send the album announcement to EVERYONE on the list?") && send({ confirm: true }, "blast")}
        disabled={sending !== null}
        data-testid="album-blast-send-btn"
        className="mt-3 w-full inline-flex items-center justify-center gap-2 text-[11px] uppercase tracking-[0.28em] text-black bg-[#D4AF37] hover:bg-[#e6c457] disabled:opacity-60 px-5 py-3.5 font-bold transition-colors"
      >
        {sending === "blast" ? <Loader2 size={14} className="animate-spin" /> : <Send size={14} />}
        Send to the whole Pack
      </button>

      {result && result.mode === "blast" && (
        <p className="mt-3 text-[11px] text-white/55" data-testid="album-blast-result">
          Sent: {result.sent_count} · Already had it: {result.skipped_already_sent} · Failed: {result.failed_count}
        </p>
      )}
    </div>
  );
};
